var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#6c5ffc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-1.3043478260869565s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#05c3fb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-1.1594202898550725s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#6c5ffc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-1.0144927536231882s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#05c3fb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-0.8695652173913043s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#6c5ffc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-0.7246376811594203s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#05c3fb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-0.5797101449275363s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#6c5ffc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-0.43478260869565216s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#05c3fb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-0.2898550724637681s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#6c5ffc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "-0.14492753623188406s",
    repeatCount: "indefinite"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(324 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 24.5,
    rx: 8.5,
    ry: 2.5,
    width: 17,
    height: 5,
    fill: "#05c3fb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.4492753623188404s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.f08eba13cf23272d435cbcb29571d1ec.svg";
export { ForwardRef as ReactComponent };